/**
 * Strip a leading "API - " automation prefix from an eblast deployment / campaign title.
 *
 * The send platform names deployments created through its API "API - <name>"; that prefix is internal
 * plumbing, not something staff (or a client) should read. Display-only — the raw name is unchanged in
 * the data. Mirrors `stripApiPrefix` in the generate worker's email builder, so the list screens and the
 * generated report agree. Dash-gated (a real "API Testing" name, with no dash, is left alone) and
 * case-insensitive.
 */
export function stripApiPrefix(name: string | null | undefined): string {
  if (name == null) return '';
  return String(name).replace(/^\s*API\s*-\s*/i, '').trim();
}
